import React, { createContext, useContext, useState, useRef, useEffect, useCallback } from "react";

const ExperienceContext = createContext(null);

export const useExperience = () => useContext(ExperienceContext);

export const ExperienceProvider = ({ children }) => {
  const [energy, setEnergy] = useState("balanced");
  const [palette, setPalette] = useState(() => {
    try { return localStorage.getItem("cm_palette") || "regal"; } catch (e) { return "regal"; }
  });
  const [shape, setShape] = useState("soft");
  const pulseRef = useRef({ value: 0, at: 0 });
  const [pulseTick, setPulseTick] = useState(0);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-palette", palette);
    root.setAttribute("data-energy", energy);
    root.setAttribute("data-shape", shape);
    try { localStorage.setItem("cm_palette", palette); } catch (e) {}
  }, [palette, energy, shape]);

  const pulse = useCallback((strength = 1) => {
    pulseRef.current = { value: strength, at: performance.now() };
    setPulseTick((t) => t + 1);
  }, []);

  return (
    <ExperienceContext.Provider
      value={{ energy, setEnergy, palette, setPalette, shape, setShape, pulse, pulseRef, pulseTick }}
    >
      {children}
    </ExperienceContext.Provider>
  );
};
